export const financesRoutes = [
  {
    path: 'finances',
    children: [],
  },
];
